<script>
import paginationMixin from '@/mixins/paginationMixin.js'
import fetchDataMixin from '@/mixins/fetchDataMixin.js'
import TwButton from '@/components/generic/tw-button.vue'
import { ChevronRightIcon } from '@heroicons/vue/24/outline'

import FundraiserPageCard from '@/components/fundraiser-pages/public/cards/fundraiser-page-card.vue'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'

export default {
  name: 'TopFundraiserPages',
  components: { FundraiserPageCard, TwButton, ChevronRightIcon },
  mixins: [fetchDataMixin, paginationMixin],
  data() {
    return {
      FundraiserCategorySelected:null
    }
  },
  computed: {
    fundraiserPages() {
      return useFundraiserPagePublicStore('top-home').getItems.slice(0, 4)
    }
  },
  mounted() {
    this.fetchFeaturedFundraisers()
  },
  methods: {
    async fetchFeaturedFundraisers() {
      try {
        this.Loading = true
        await useFundraiserPagePublicStore('top-home').fetchItems({
          featured: 1,
          ...(this.FundraiserCategorySelected && { fundraiser_category_id: this.FundraiserCategorySelected.id } ),
        })
        this.Loading = false
      } catch (e) {
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    setFundraiserCategory(fundraiserCategory) {
      this.FundraiserCategorySelected = fundraiserCategory
      this.fetchFeaturedFundraisers()
    }
  }
}
</script>

<template>
  <div>
    <div class="flex w-full justify-between items-center mb-6 md:mb-10">
    <h2>
      Top Individual Fundraisers
    </h2>
    <tw-button variant="link" class="gap-1 hidden md:flex">
      View More
      <ChevronRightIcon class="size-4" aria-hidden="true" />
    </tw-button>
    <!-- <p class="mt-2">
      Top individuals who've raised the most for their organization
      </p> -->
  </div>
    <TransitionGroup
      enter-active-class="duration-200 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0" tag="div" name="fadeIn" class="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-7"
    >
      <fundraiser-page-card v-for="fundraiser in fundraiserPages" :key="'card-' + fundraiser.id" :fundraiser-page="fundraiser" />
    </TransitionGroup>
    <tw-button variant="secondary" class="mt-6 flex gap-1 md:hidden w-full justify-center">
      View More Fundraisers
      <ChevronRightIcon class="size-4" aria-hidden="true" />
    </tw-button>
  </div>
</template>

<style scoped>

</style>
